import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import './style.css';
import { useLocation } from 'react-router-dom';
import { addYears, format, addMonths } from 'date-fns';

export function ConteudoPcmso(props: any) {
    const [nomeResponsavel, setNomeResponsavel] = useState('');
    const [cargoResponsavel, setCargoResponsavel] = useState('');
    const [crmResponsavel, setCrmResponsavel] = useState('');
    const [registroResponsavel, setRegistroResponsavel] = useState('');


    const [nomeRevisao, setNomeRevisao] = useState('');
    const [vigenciaRevisao, setVigenciaRevisao] = useState('');
    const [historicoData, setHistoricoData] = useState<any[]>([]);
    const [revisoes, setRevisoes] = useState([])
    const [endDate, setEndDate] = useState('');

    let contador = 0;

    function getContador() {
        return String(contador++).padStart(2, '0');
    }

    function formatarDataRevisao(dataOriginal: string, mesesParaAdicionar: number) {
        let data = new Date(dataOriginal);
        data = addMonths(data, mesesParaAdicionar);
        return format(data, 'dd/MM/yyyy');
    }


    //Buscar Responsável
    const fetchResponsavel = async () => {
        try {
            const response = await api.get(`listar-responsavel-por-empresa/${props.props.idEmpresa}`);
            if (response && response.data) {
                setNomeResponsavel('Maurício Cheratzki');
                setCargoResponsavel(response.data[0].cargo);
                setCrmResponsavel(response.data[0].tipo_profissional);
                setRegistroResponsavel(response.data[0].registro_profissional);
            }
        } catch (error) {
            console.error("Erro ao buscar histórico:", error);
        }
    };

    function buscarData() {
        const today = new Date();
        const twoYearsLater = addYears(today, 2);

        // Formatando as datas para o formato desejado: dd/MM/yyyy
        return {
            startDate: format(today, 'dd/MM/yyyy'),
            endDate: format(twoYearsLater, 'dd/MM/yyyy')
        };
    }

    // Função para buscar o histórico
    const fetchHistorico = async () => {
        try {
            const response = await api.get(`listar-historico-documento/${props.props.idFdt}`);
            const responseData = response.data;

            const revisoesFiltradas = responseData.revisoes.filter(
                (rev: any) => rev.nome === 'Revisão' || !rev.id_emissao
            );

            const dadosFiltrados = responseData.historico
                .sort((a: any, b: any) => a.funcao.pgrGhe.nome.localeCompare(b.funcao.pgrGhe.nome));


            console.log(responseData.historico)
            console.log(dadosFiltrados)

            setHistoricoData(dadosFiltrados);
            setRevisoes(revisoesFiltradas);
        } catch (error) {
            console.error("Erro ao buscar histórico:", error);
        }
    };

    useEffect(() => {
        fetchHistorico();
        fetchResponsavel()
    }, [props.props.idRevisao, props.props.idEmpresa]);

    useEffect(() => {
        const obterNomeFdt = async () => {
            if (props.props.idRevisao) {
                try {
                    const response = await api.post(`listar-revisao/${props.props.idRevisao}/${props.props.idEmpresa}`);
                    if (response && response.data && response.data.length > 0) {
                        setNomeRevisao(response.data[0].nome);
                        const dataVigencia = formatarDataRevisao(response.data[0].created_at, 1);
                        setVigenciaRevisao(dataVigencia);
                    }
                } catch (error) {
                    console.error('Erro ao obter o nome da FDT:', error);
                }
            }
        };
        obterNomeFdt();
    }, [props.props.idRevisao]);

    const getDataDeHoje = () => {
        const hoje = new Date();
        return hoje.toLocaleDateString('pt-BR');
    };
    const uniqueRevisoes = new Map();
    historicoData.forEach((item, index) => {
        if (!uniqueRevisoes.has(item.revisao.id)) {
            uniqueRevisoes.set(item.revisao.id, uniqueRevisoes.size + 1);
        }
    });

    function formatarDataISO(dataISO: string): string {
        // A dataISO é assumida como estando no formato "YYYY-MM-DD"
        const partes = dataISO.split('-'); // Divide a string pela hifen
        // Reorganiza as partes para o formato "DD/MM/YYYY"
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }
    //TODAS AS REVISÕES

    //IDENTIFICAÇÃO DA EMPRESA
    const [empresaId, setEmpresaId] = useState("");
    const [empresaRazaoSocial, setEmpresaRazaoSocial] = useState("");
    const [empresaCNPJ, setEmpresaCNPJ] = useState("");
    const [empresaEndereco, setEmpresaEndereco] = useState("");
    const [empresaEndNumero, setEmpresaEndNumero] = useState("");
    const [empresaCep, setEmpresaCep] = useState("");
    const [empresaBairro, setEmpresaBairro] = useState("");
    const [empresaCidade, setEmpresaCidade] = useState("");
    const [empresaEstado, setEmpresaEstado] = useState("");
    const [empresaTelefone, setEmpresaTelefone] = useState("");
    const [empresaCelular, setEmpresaCelular] = useState("");
    const [empresaEmail, setEmpresaEmail] = useState("");
    // const [empresaCei, setEmpresaCei] = useState("");
    const [empresaCnae, setEmpresaCnae] = useState("");
    const [empresaInscEstadual, setEmpresaIsncEstadual] = useState("");

    const [empresaRespNome, setEmpresaRespNome] = useState("");
    const [empresaRespEmail, setEmpresaRespEmail] = useState("");
    const [empresaRespCargo, setEmpresaRespCargo] = useState("");
    const [empresaRespTelefone, setEmpresaRespTelefone] = useState("");

    const location = useLocation();
    const pathName = location.pathname;
    const routeName = pathName.substring(pathName.lastIndexOf('/') + 1).toUpperCase();


    useEffect(() => {
        const buscarDadosEmpresa = async () => {
            try {
                const response = await api.get(`/empresas/listar/${props.props.idEmpresa}`);
                const empresa = response.data;

                setEmpresaId(empresa.id);
                setEmpresaRazaoSocial(empresa.nome);
                setEmpresaCNPJ(empresa.cnpj);
                setEmpresaEndereco(empresa.endereco)
                setEmpresaEndNumero(empresa.numero)
                setEmpresaCep(empresa.cep)
                setEmpresaBairro(empresa.bairro)
                setEmpresaCidade(empresa.cidade)
                setEmpresaEstado(empresa.estado)
                setEmpresaTelefone(empresa.telefone)
                setEmpresaCelular(empresa.celular)
                setEmpresaEmail(empresa.email)
                // setEmpresaCei(empresa.cei);
                setEmpresaCnae(empresa.cnae);
                setEmpresaIsncEstadual(empresa.insc_estadual);

                setEmpresaRespNome(empresa.resp_empresa_nome);
                setEmpresaRespEmail(empresa.resp_empresa_email);
                setEmpresaRespCargo(empresa.resp_empresa_cargo);
                setEmpresaRespTelefone(empresa.resp_empresa_telefone);

            } catch (error) {
                console.error('Erro ao buscar dados da empresa', error);
            }
        };

        buscarDadosEmpresa();
    }, [props.props.idEmpresa]);

    //DadosFdt
    const [fdtId, setFdtId]: any = useState("");
    const [fdtGrauRisco, setFdtGrauRisco]: any = useState("");
    useEffect(() => {
        const buscarDadosFdt = async () => {
            try {
                const response = await api.post(`listar-fdt/${props.props.idFdt}`, { id_empresa: props.props.idEmpresa });
                const fdt = response.data.fdt[0];

                setFdtId(fdt.id);
                setFdtGrauRisco(fdt.grau_risco);

            } catch (error) {
                console.error('Erro ao buscar dados da empresa', error);
            }
        };

        buscarDadosFdt();
    }, [props.props.idFdt]);

    //DADOS FUNCIONARIOS
    const [funcionarios, setFuncionarios]: any = useState([]);

    useEffect(() => {
        const loadEmployees = async () => {
            try {
                const response = await api.post('funcionarios', { id_empresa: props.props.idEmpresa });
                setFuncionarios(response.data);
            } catch (error) {
                console.error("Error fetching funcionarios:", error);
            }
        };
        loadEmployees()
    }, [props.props.idEmpresa]);

    useEffect(() => {
        const obterNomeFdt = async () => {
            if (props.props.idRevisao) {
                try {
                    const response = await api.post(`listar-revisao/${props.props.idRevisao}/${props.props.idEmpresa}`);
                    if (response && response.data && response.data.revisao.length > 0) {
                        setNomeRevisao(response.data.revisao[0].nome);
                        const dataRevisao = response.data.revisao[0].created_at; // Data da revisão
                        const dataVigencia = formatarDataRevisao(dataRevisao, 0); // Data da revisão
                        setVigenciaRevisao(dataVigencia);

                        // Calcula endDate adicionando 12 meses à data da revisão
                        const dataFimVigencia = formatarDataRevisao(dataRevisao, 12);
                        setEndDate(dataFimVigencia);
                    }
                } catch (error) {
                    console.error('Erro ao obter o nome da FDT:', error);
                }
            }
        };
        obterNomeFdt();
    }, [props.props.idRevisao]);

    // useEffect(() => {

    //     const handleListFunction = async (inputValue: any) => {
    //         const response = await api.get(`funcionarios/buscar-funcao/${inputValue}`);
    //         const responseData = response.data;
    //     };
    //     handleListFunction('encanador')
    // }, [funcionariosTotal]);

    //DADOS DAS FUNÇÕES
    const [funcoes, setFuncoes] = useState([]);
    const [riscosExames, setRiscosExames] = useState([]);
    console.log("🚀 ~ ConteudoPcmso ~ riscosExames:", riscosExames)
    const [riscosFuncoes, setRiscosFuncoes] = useState([]);
    const [uniqueGHEs, setUniqueGHEs] = useState([]);
    const [riscos, setRiscos] = useState([]);
    const [acoesCronograma, setAcoesCronograma]: any = useState([]);
    const [intervalosCronograma, setIntervalosCronograma] = useState([]);



    useEffect(() => {
        const fetchFuncoesERiscos = async () => {
            try {
                const response = await api.post('listar-pgr', {
                    id_empresa: props.props.idEmpresa,
                    id_fdt: props.props.idFdt,
                    id_revisao: props.props.idRevisao,
                    id_ghe: props.props.idGhe,
                    tipo_documento: routeName,
                });

                const examesUnicos = response.data.riscosExames.filter((exame: { ateBaseExames: { nome: any; }; }, index: any, self: any[]) =>
                    index === self.findIndex((e: { ateBaseExames: { nome: any; }; }) => (
                        e.ateBaseExames.nome === exame.ateBaseExames.nome
                    ))
                );



                const funcoesOrdenadas = response.data.funcoes.sort((a: any, b: any) => {
                    const nomeA = a.pgrGhe.nome.toUpperCase();
                    const nomeB = b.pgrGhe.nome.toUpperCase();
                    if (nomeA < nomeB) {
                        return -1;
                    }
                    if (nomeA > nomeB) {
                        return 1;
                    }
                    return 0;
                });
                console.log("🚀 ~ funcoesOrdenadas ~ funcoesOrdenadas:", funcoesOrdenadas)

                setFuncoes(funcoesOrdenadas);
                setRiscosExames(examesUnicos);
                setRiscosFuncoes(response.data.riscosFuncoes);
                setAcoesCronograma(response.data.acoes_cronograma);
                setIntervalosCronograma(response.data.intervalo_cronograma);

                const ghes = Array.from(
                    new Set(
                        response.data.funcoes.map((funcao: any) => ({
                            id: funcao.pgrGhe.id,
                            nome: funcao.pgrGhe.nome,
                        }))
                    )
                );

                const uniqueGhesMap: any = new Map(ghes.map((ghe: any) => [ghe.id, ghe]));
                setUniqueGHEs(Array.from(uniqueGhesMap.values()));

                const riscosFiltrados = response.data.riscos.filter((risco: any) =>
                    uniqueGhesMap.has(risco.id_ghe)
                );
                setRiscos(riscosFiltrados);

            } catch (error) {
                console.error('Erro ao buscar GHEs:', error);
            }
        };
        fetchFuncoesERiscos();
    }, [props.props.idEmpresa, props.props.idFdt, props.props.idRevisao, props.props.idGhe]);

    const filtrarRiscosPorGHE = (idGhe: any) => riscos.filter((risco: any) => risco.id_ghe === idGhe);

    const agruparFuncoesPorGHE = (gheId: any) => funcoes.filter((funcao: any) => funcao.pgrGhe.id === gheId);

    const renderizarFuncoes = (funcoesPorGHE: any) => {
        let linhasDeFuncoes = [];
        for (let i = 0; i < funcoesPorGHE.length; i += 4) {
            let funcoesSubconjunto = funcoesPorGHE.slice(i, i + 4);
            while (funcoesSubconjunto.length < 4) {
                funcoesSubconjunto.push({ AteBaseFuncao: { nome: "-" } });
            }
            linhasDeFuncoes.push(
                <div className="table-tr inv-fun" key={`funcoes-${i}`}>
                    <div className='table-td th'>FUNÇÕES</div>
                    {funcoesSubconjunto.map((funcao: any, index: any) => (
                        <div className='table-td' key={`funcao-${index}`}>{funcao.AteBaseFuncao.nome}</div>
                    ))}
                </div>
            );
        }
        return linhasDeFuncoes;
    };
    function mapearValorParaDescricao(valor: string) {
        if (valor === "Baixa") return '1';
        if (valor === "Média") return '2';
        if (valor === "Alta") return '3';
        if (valor === "Muito Alta") return '4';
        return "N/A"; // Caso o valor não esteja no intervalo esperado
    }
    function gerarGrauDeRisco(probabilidade: any, severidade: any): string {
        if (probabilidade == null || severidade == null) {
            return "Dados insuficientes";
        }

        const descricaoProbabilidade = mapearValorParaDescricao(probabilidade);
        const descricaoSeveridade = mapearValorParaDescricao(severidade);

        if (!descricaoProbabilidade || !descricaoSeveridade) {
            return "Valores não mapeáveis";
        }

        return `P${descricaoProbabilidade} x S${descricaoSeveridade}`;
    }

    //DADOS DA CIPA
    const [gpCipa, setGpCipa]: any = useState([]);
    const [atividadeCipa, setAtividadeCipa]: any = useState([]);

    const formatCnae = (cnae: any) => {

        let cleanCnae = cnae.replace(/[^\d]/g, '');
        return `${cleanCnae.slice(0, 2)}.${cleanCnae.slice(2, 4)}-${cleanCnae.slice(4, 5)}`;
    };

    const fetchCipa = async () => {
        try {
            if (empresaCnae) {
                const formattedCnae = formatCnae(empresaCnae);
                const response = await api.post(`listar-cipa/${formattedCnae}`);
                setGpCipa(response.data[0].gp_cipa);
                setAtividadeCipa(response.data[0].atividade);
            }
        } catch (error) {
            console.error('Erro ao buscar GHEs:', error);
        }
    };

    useEffect(() => {
        fetchCipa()
    }, [props.props.idEmpresa, empresaCnae]);

    //DADOS DA DIMENSIONAMENTO CIPA
    const [dimensionamentoCipa, setDimensionamentoCipa]: any = useState([]);

    const fetchDimensionamentoCipa = async () => {
        try {
            const response = await api.get(`listar-dimensionamento-cipa/${gpCipa}`);
            setDimensionamentoCipa(response.data)
        } catch (error) {
            console.error('Erro ao buscar GHEs:', error);
        }
    };

    useEffect(() => {
        fetchDimensionamentoCipa()
    }, [props.props.idEmpresa, gpCipa]);

    const [datasExibidas, setDatasExibidas] = useState(new Set());

    //Cronograma

    const meses: any = {
        Jan: "Jan",
        Feb: "Fev",
        Mar: "Mar",
        Apr: "Abr",
        May: "Maio",
        Jun: "Jun",
        Jul: "Jul",
        Aug: "Ago",
        Sep: "Set",
        Oct: "Out",
        Nov: "Nov",
        Dec: "Dez",
    };

    const formatarIntervaloExecucoes = (intervalo: any) => {
        const [mesEn, ano]: any = intervalo.split('/');
        const mesPt = meses[mesEn.trim()] || mesEn;
        return `${mesPt.trim()} / ${ano.trim()}`;
    };

    const renderizarRiscos = (gheId: any) => {
        const riscosFiltrados = filtrarRiscosPorGHE(gheId);

        if (riscosFiltrados.length > 0) {
            return riscosFiltrados.map((risco: any) => (
                <div className="table-tr inv-props" key={risco.id}> {/* Certifique-se de que risco.id seja único */}
                    <div className='table-td '>{risco.categoria}</div>
                    <div className='table-td '>{risco.risco}</div>
                    <div className='table-td '>{risco.fonte_geradora}</div>
                    <div className='table-td '>{risco.possiveis_danos_a_saude}</div>
                    <div className='table-td '> {gerarGrauDeRisco(risco.probabilidade, risco.severidade)}</div>
                    <div className='table-td '>{gerarGrauDeRisco(risco.probabilidade_pgr, risco.severidade_pgr)}</div>
                    <div className='table-td '>{risco.medidas_de_controle_propostas}</div>
                    <div className='table-td '>{risco.cronograma}</div>
                    <div className='table-td '>{risco.formas_de_acompanhamento}</div>
                    <div className='table-td '>{risco.afericao_dos_resultados}</div>
                </div>
            ));
        } else {
            return (
                <div className="table-tr inv-props">
                    <div className='table-td f-100'>Nenhum risco encontrado para o GHE selecionado.</div>
                </div>
            );
        }
    };

    const funcionariosTotal = funcoes.reduce((total: number, item: any) => {
        return total + (item.num_tra_masc + item.num_tra_fem);
    }, 0);


    return (
        <>
            <div className="main-title">
                <h6><b>PCMSO - PROGRAMA DE CONTROLE MÉDICO DE SAÚDE OCUPACIONAL</b></h6>
            </div>

            <div className="main-title">
                <h6><b>Apresentação</b></h6>
            </div>
            <div className='paragraph'>
                O PCMSO é previsto pela portaria do Ministério do Trabalho nº 24 de 29/12/94 na Norma Regulamentadora nº
                7, a qual determina que todos os empregadores ou instituições que admitam trabalhadores como empregados
                regidos pela CLT - Consolidação das Leis do Trabalho, elaborem e implementem tal programa.
            </div>
            <div className='paragraph'>
                O PCMSO é parte integrante do conjunto mais amplo de iniciativas da empresa no campo da saúde dos
                trabalhadores, devendo estar articulado com o disposto nas demais Normas Regulamentadoras de Segurança e
                Medicina do Trabalho. Deve considerar as questões incidentes sobre o indivíduo e a coletividade de
                trabalhadores, dando ênfase à parte clínica e epidemiológica na abordagem da relação entre a Saúde e
                Segurança do Trabalho.
            </div>
            <div className='paragraph'>
                O PCMSO deve ter caráter de prevenção com promoção da Saúde, rastreamento e diagnóstico precoce com
                recuperação dos agravos à saúde relacionados ao trabalho, além da constatação da existência de casos de
                doenças profissionais ou danos à saúde dos trabalhadores.
            </div>
            <div className='paragraph'>
                O PCMSO é um documento escrito que norteia as ações práticas do programa, devendo ser elaborado por
                Médico do Trabalho, onde o nível de sua complexidade depende basicamente dos riscos existentes em cada
                empresa.
            </div>

            <div className='tituloCap' data-sum>HISTÓRICO DE REVISÃO</div>
            <div className='table-div history'>
                <div className="table-tr" style={{ borderTop: '1px solid #000' }}>
                    <div className="table-td th">HISTÓRICO DE REVISÃO</div>
                </div>

                <div className='table-tr cab'>
                    <div className='table-td th'>Revisão</div>
                    <div className='table-td th'>Oficialização</div>
                    <div className='table-td th'>Descrição da Revisão</div>
                </div>

                {historicoData.length > 0 ? (
                    <>
                        {revisoes.map((revisao: any) => (
                            <React.Fragment key={revisao.id}>
                                <div className='table-div hist'>
                                    <div className='table-tr cab'>
                                        <div className='table-td'>{getContador()}</div>
                                        <div className='table-td'>{new Date(revisao.created_at).toLocaleDateString('pt-BR')}</div>
                                        <div className='table-td'>{revisao.nome}</div>
                                    </div>
                                </div>

                                {historicoData
                                    .filter(item => item.id_revisao === revisao.id && revisao.nome === 'Revisão')
                                    .map((item) => (
                                        <div key={item.id} className='table-div hist'>
                                            <div className='table-tr cab'>
                                                <div className='table-td'>{String(contador - 1).padStart(2, '0')}</div>
                                                <div className='table-td'>{new Date(item.revisao.created_at).toLocaleDateString('pt-BR')}</div>
                                                <div className='table-td'>
                                                    {`Função de ${item.funcao.AteBaseFuncao.nome} no ${item.funcao.pgrGhe.nome}`}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </React.Fragment>
                        ))}
                    </>
                ) : (
                    <div className='table-tr cab'>
                        <div className='table-td-data' style={{ flex: '0 0 100% !important', textAlign: 'center' }}>Sem dados!</div>
                    </div>
                )}
            </div>
            <div className='tituloCap' data-new-page data-sum>1. IDENTIFICAÇÃO DA EMPRESA</div>
            <div className="table-div razao-social">
                <div className="table-tr">
                    <div className="table-td  colspan2">
                        <b>RAZÃO SOCIAL:</b><br />
                        {empresaRazaoSocial}
                    </div>
                    <div className="table-td"><b>CNPJ:</b><br />{empresaCNPJ}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td colspan2"><b>ENDEREÇO: </b><br />{empresaEndereco}, {empresaEndNumero}</div>
                    <div className="table-td"><b>CEP:</b><br />{empresaCep}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td"><b>BAIRRO:</b><br />{empresaBairro}</div>
                    <div className="table-td"><b>CIDADE:</b><br />{empresaCidade}</div>
                    <div className="table-td"><b>UF:</b><br />{empresaEstado}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td"><b>TELEFONE:</b><br />{empresaTelefone}</div>
                    <div className="table-td"><b>TELEFONE CELULAR:</b><br />{empresaCelular}</div>
                    <div className="table-td"><b>E-MAIL:</b><br />{empresaEmail}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td colspan3"><b>RAMO DE ATIVIDADE:</b><br />{atividadeCipa}</div>
                    <div className="table-td"></div>
                    <div className="table-td"></div>
                </div>
                <div className="table-tr">
                    <div className="table-td"><b>CNAE:</b><br />{empresaCnae}</div>
                    <div className="table-td"><b>GRAU DE RISCO (NR 4): {fdtGrauRisco}</b></div>
                    <div className="table-td"><b>INSCRIÇÃO ESTADUAL:</b><br />{empresaInscEstadual}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td colspan3"><b>TOTAL DE TRABALHADORES:</b><br />{funcionariosTotal}</div>
                </div>
                <div className="table-tr">
                    <div className="table-td"><b>RESPONSÁVEL PELA EMPRESA:</b></div>
                    <div className="table-td"><b>NOME:</b> {empresaRespNome}</div>
                    <div className="table-td"><b>CARGO:</b> {empresaRespCargo}</div>
                </div>
                <div className="table-tr" style={{ borderWidth: '1px', color: '#000' }}>
                    <div className="table-td colspan2" ><b>TELEFONE:</b> {empresaRespTelefone}</div>
                    <div className="table-td"><b>E-MAIL:</b> {empresaRespEmail}</div>
                </div>
            </div>
            <div className='paragraph'>
                Código da Atividade (conforme cartão CNPJ).<br />
                <b>{empresaCnae} - {atividadeCipa}</b><br />
                Em conformidade com a NR-4 do MTE, QUADRO I, com redação dada pela Portaria nº. 76, de 21/11/2008, a
                empresa caracteriza-se com <span className='bold'>grau de risco {fdtGrauRisco}.</span>
            </div>
            <div className='tituloCap' data-new-page data-sum>2. VIGÊNCIA</div>
            <div className='paragraph'>
                Este PCMSO terá vigência de {vigenciaRevisao} a {endDate}.
            </div>
            <div className='tituloCap' data-sum>3. RESPONSABILIDADE TÉCNICA</div>
            <div className='paragraph'>
                Empresa: Atento Medicina do Trabalho
                Responsável: DR. MAURICIO CHERATZKI, CRM: 15302/PR
            </div>
            <div className='tituloCap' data-sum>4. SESMT</div>
            <div className='paragraph'>
                Operacionalizar o PCMSO, juntamente com a área médica.
            </div>
            <div className='paragraph'>
                As empresas deverão manter, obrigatoriamente, Serviços Especializados em Engenharia de Segurança e em
                Medicina do Trabalho - SESMT, com a finalidade de promover a saúde e proteger a integridade do trabalhador
                no local de trabalho.
            </div>
            <div className='paragraph'>
                A NR-4 do MTE estabelece:
            </div>
            <div className='paragraph'>
                4.1. As empresas privadas e públicas, os órgãos públicos da administração direta e indireta e dos poderes
                Legislativo e Judiciário, que possuam empregados regidos pela Consolidação das Leis do Trabalho - CLT,
                manterão, obrigatoriamente, Serviços Especializados em Engenharia de Segurança e em Medicina do Trabalho,
                com a finalidade de promover a saúde e proteger a integridade do trabalhador no local de trabalho. (C =
                104.001-4 / I = 2)
            </div>
            <div className='paragraph'>
                4.2. O dimensionamento dos Serviços Especializados em Engenharia de Segurança e em Medicina do Trabalho
                vincula-se à gradação do risco da, atividade principal e ao número total de empregados do estabelecimento,
                constantes dos Quadros I e II, anexos, observadas as exceções previstas nesta NR. (C = 104.002-2 / I = 1)
            </div>
            <div className='paragraph'>
                4.20. Quando se tratar de empreiteiras ou empresas prestadoras de serviços, considera-se estabelecimento,
                para fins de aplicação desta NR, o local em que os seus empregados estiverem exercendo suas atividades.
            </div>
            <div className='table-div sesmt'>
                <div className='table-tr' style={{ borderTop: '1px solid' }}>
                    <div className='table-td th'>Grau de Risco</div>
                    <div className='table-td th'>
                        <div className='horizontal-td'>
                            Nº de Empregados no Estabelecimento
                        </div>
                        <div>
                            Nº de Membros da CIPA
                        </div>
                    </div>
                    <div className='table-td th'>50 a 100</div>
                    <div className='table-td th'>101 a 250</div>
                    <div className='table-td th'>251 a 500</div>
                    <div className='table-td th'>501 a 1000</div>
                    <div className='table-td th'>1001 a 2000</div>
                    <div className='table-td th'>2001 a 3500</div>
                    <div className='table-td th'>3501 a 5000</div>

                    <div className='table-td th'>Acima de 5.000 para cada grupo de 4.000 ou fração acima de 2.000**</div>
                </div>
                {/*/////////////////////////////////////////*/}
                {fdtGrauRisco == 4 && (
                    <>
                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Técnico Seg. Trabalho</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>3</div>
                            <div className='table-td'>4</div>
                            <div className='table-td'>5</div>
                            <div className='table-td'>8</div>
                            <div className='table-td'>10</div>
                            <div className='table-td'>3</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Engenheiro Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>3</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Aux. Enfermagem Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>

                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Enfermeiro do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>-</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>4</div>
                            <div className='table-td'>Médico do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>3</div>
                            <div className='table-td'>1</div>
                        </div>
                    </>
                )}
                {/*//////////////////////////////////////////////////////////////*/}
                {fdtGrauRisco == 3 && (
                    <>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Técnico Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>3</div>
                            <div className='table-td'>4</div>
                            <div className='table-td'>6</div>
                            <div className='table-td'>8</div>
                            <div className='table-td'>3</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Engenheiro Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Aux. Enfermagem Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Enfermeiro do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>-</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>3</div>
                            <div className='table-td'>Médico do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>1</div>
                        </div>
                    </>
                )}
                {/*|||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
                {fdtGrauRisco == 2 && (
                    <>
                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Técnico Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>5</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Engenheiro Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1*</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Aux. Enfermagem Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>

                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Enfermeiro do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>-</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>2</div>
                            <div className='table-td'>Médico do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>
                    </>
                )}
                {/*|||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
                {fdtGrauRisco == 1 && (
                    <>
                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Técnico Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>2</div>
                            <div className='table-td'>1</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Engenheiro Seg. Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1*</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Aux. Enfermagem Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1***</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1</div>
                        </div>

                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Enfermeiro do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>-</div>
                        </div>
                        <div className='table-tr'>
                            <div className='table-td'>1</div>
                            <div className='table-td'>Médico do Trabalho</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>-</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1*</div>
                            <div className='table-td'>1</div>
                            <div className='table-td'>1*</div>
                        </div>
                    </>
                )}
                {/*|||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
                <div style={{ marginTop: '10px' }}>
                    (*) Tempo parcial (mínimo de três horas)
                </div>
                <div style={{ marginTop: '10px' }}>
                    (**) O dimensionamento total deverá ser feito levando-se em consideração o dimensionamento da faixa de
                    3.501 a 5.000, acrescido do dimensionamento do(s) grupo(s) de 4.000 ou fração acima de 2.000.
                </div>
                <div style={{ marginTop: '10px' }}>OBSERVAÇÕES:</div>
                <div style={{ marginTop: '10px' }}>
                    Hospitais, Ambulatórios, Maternidades, Casas de Saúde e
                    Repouso, Clínicas e estabelecimentos similares com mais de 500
                    (quinhentos) empregados deverão contratar um Enfermeiro do
                    Trabalho em tempo integral.
                </div>
            </div>
            <div className='tituloCap' data-new-page data-sum>5. LEGISLAÇÃO</div>
            <div className='paragraph'>
                Em atendimento à Norma Regulamentadora n° 7 (NR-7), <b>PORTARIA Nº 6.734, DE 9 DE MARÇO DE 2020.</b>
            </div>
            <div className='tituloCap' data-sum>6. DEFINIÇÕES E SIGLAS</div>
            <div className='paragraph'>
                <b>ABNT: </b>Associação Brasileira de Normas Técnicas;
            </div>
            <div className='paragraph'>
                <b>Acidente: </b>Evento imprevisto e indesejável, instantâneo ou não, que resultou em dano à pessoa (inclui a
                doença do trabalho e a doença profissional), ao patrimônio (próprio ou de terceiros) ou impacto ao meio
                ambiente. Nota: Segundo a legislação brasileira (Lei 8.213/98), as doenças ocupacionais estão incluídas no
                conceito de acidente do trabalho;

            </div>
            <div className='paragraph'>
                <b>Anomalia: </b>Situação ou evento indesejável que resulte ou que possa resultar em danos ou falhas que afetem
                pessoas, o meio ambiente, o patrimônio (próprio ou de terceiros), os produtos ou os processos produtivos;
            </div>
            <div className='paragraph'>
                <b>APR: </b>Análise Preliminar de Riscos;

            </div>
            <div className='paragraph'>
                <b>ASO: </b>Atestado de Saúde Ocupacional;

            </div>
            <div className='paragraph'>
                <b>CAT: </b>Comunicação de Acidente de Trabalho;
            </div>
            <div className='paragraph'>
                <b>CNAE: </b>Código Nacional de Atividade Econômica;
            </div>
            <div className='paragraph'>
                <b>CNPJ: </b>Cadastro Nacional de Pessoa Jurídica;
            </div>
            <div className='paragraph'>
                <b>CRM: </b>Conselho Regional de Medicina;
            </div>
            <div className='paragraph'>
                <b>Empregador: </b>conforme a NR 1, considera-se empregador, a empresa, individual ou coletiva, que assumindo os
                riscos da atividade econômica, admite, assalaria e dirige a prestação pessoal de serviços;
            </div>
            <div className='paragraph'>
                <b>EPI: </b>Equipamento de Proteção Individual;
            </div>
            <div className='paragraph'>
                <b>EPC: </b>Equipamento de Proteção Coletiva;
            </div>
            <div className='paragraph'>
                <b>FDT: </b>Frente de Trabalho;
            </div>
            <div className='paragraph'>
                <b>GHE: </b>Grupo Homogêneo de Exposição;
            </div>
            <div className='paragraph'>
                <b>HHER: </b>Homem-hora de Exposição ao Risco;
            </div>
            <div className='paragraph'>
                <b>Incidente: </b>Evento relacionado ao trabalho no qual uma lesão ou doença ou fatalidade ocorreu ou poderia
                ocorrer;
            </div>
            <div className='paragraph'>
                <b>LER: </b>Lesões por Esforços Repetitivos;
            </div>
            <div className='paragraph'>
                <b>LTCAT: </b>Laudo Técnico das Condições Ambientais de Trabalho (Avaliação técnica dos agentes ambientais nos
                locais de trabalho);
            </div>
            <div className='paragraph'>
                <b>Limite de Tolerância (LT): </b>Concentração ou intensidade máxima ou mínima, relacionada com a natureza e o
                tempo de exposição ao agente, que não causará dano à saúde do trabalhador, durante a sua vida laboral;
            </div>
            <div className='paragraph'>
                <b>LV: </b>Lista de Verificação;
            </div>
            <div className='paragraph'>
                <b>MTE: </b>Ministério do Trabalho e Emprego;
            </div>
            <div className='paragraph'>
                <b>NIOSH: </b>National Institute of Occupational Safety and Health; Nível de Ação Valor equivalente a 50% da DOSE
                para ruído e metade do LT para agentes químicos a partir do qual devem ser iniciadas medidas preventivas de
                forma a controlar a probabilidade de que as exposições a agentes ambientais possam prejudicar a saúde do
                trabalhador;
            </div>
            <div className='paragraph'>
                <b>Não-Conformidade: </b>Não atendimento a um requisito;
            </div>
            <div className='paragraph'>
                <b>NBR: </b>Norma Brasileira;
            </div>
            <div className='paragraph'>
                <b>NPS: </b>Nível de Pressão Sonora;

            </div>
            <div className='paragraph'>
                <b>NR: </b>Norma Regulamentadora (Ministério do Trabalho e Emprego);

            </div>
            <div className='paragraph'>
                <b>PCA: </b>Programa de Conservação Auditiva;

            </div>
            <div className='paragraph'>
                <b>PCMAT: </b>Programa de Condições e Meio Ambiente na Indústria da Construção;
            </div>
            <div className='paragraph'>
                <b>PCMSO: </b>Programa de Controle Médico de Saúde Ocupacional; Perigo Situação com potencial de provocar
                lesões pessoais ou danos à saúde, ao meio ambiente ou às propriedades, ou a uma combinação destes;
            </div>
            <div className='paragraph'>
                <b>PDT: </b>Posto de Trabalho;
            </div>
            <div className='paragraph'>
                <b>PGRSS:</b> Plano de Gerenciamento de Resíduos de Serviços de Saúde
            </div>
            <div className='paragraph'>
                <b>PNOC: </b>Para as poeiras ou material particulado que são insolúveis ou de baixa solubilidade a ACGIH define
                como "PNOC". Traduzido para o português como "Partículas não Especificadas de Outra Maneira. Os PNOS são
                matérias que não devem conter asbesto em sua composição; a porcentagem de sílica deve ser inferior a 1%;
                os valores de referência servem como referência para avaliação da jornada de trabalho, no entanto, não
                devem ser utilizados para exposições de curta duração com valores altos de concentração ambiental; e Não
                devem ser aplicados para substâncias que causam alterações fisiológicas a baixas concentrações.
            </div>
            <div className='paragraph'>
                <b>PPP: </b>Perfil Profissiográfico Previdenciário;

            </div>
            <div className='paragraph'>
                <b>PPR: </b>Programa de Proteção Respiratória;

            </div>
            <div className='paragraph'>
                <b>PGR: </b>Programa de Gerenciamento de Riscos;

            </div>
            <div className='paragraph'>
                <b>PROERGO: </b> Programa de Ergonomia;

            </div>
            <div className='paragraph'>
                <b>SESMT: </b>Serviço Especializado em Engenharia de Segurança e em Medicina do Trabalho;
            </div>
            <div className='paragraph'>
                <b>SMS: </b>Segurança, Meio Ambiente e Saúde;
            </div>
            <div className='paragraph'>
                <b>TFCA: </b>Taxa de Frequência de Acidentados com Afastamento;
            </div>
            <div className='paragraph'>
                <b>TFSA: </b>Taxa de Frequência de Acidentados sem Afastamento.
            </div>
            <div className='tituloCap' data-sum>7. PRINCÍPIOS GERAIS DO PCMSO</div>
            <div className='paragraph'>
                A finalidade do PCMSO relaciona-se à busca constante da melhoria da saúde da população trabalhadora,
                alicerçando-se principalmente na prevenção, promoção, diagnóstico e recuperação da saúde desta população.
            </div>
            <div className='paragraph'>
                O PCMSO será elaborado com base nos riscos à saúde dos trabalhadores, levando em consideração as queixas,
                os sinais, os sintomas, o levantamento ambiental, PGR e o mapeamento dos riscos.
            </div>
            <div className='tituloCap' data-sum>8. MEDIDAS DE CONTROLE ORGANIZACIONAL - EMPREGADOR</div>
            <div className='paragraph'>
                A implantação deve ser garantida pelo empregador. Como a implementação, a execução do PCMSO depende
                dos atos médicos, então somente o médico poderá implementar o PCMSO.
            </div>
            <div className='paragraph'>
                O PCMSO busca promover a saúde de seus trabalhadores através de:
            </div>
            <div className='paragraph'>
                <li>Elaboração, implantação e acompanhamento do PCMSO;</li>
                <li>
                    Realização dos exames ocupacionais admissionais, periódicos, retorno ao trabalho, mudança de função,
                    demissionais e seus respectivos exames complementares como forma de monitoramento do binômio
                    risco/doença;
                </li>
                <li>
                    Confecção de parecer e comunicação interna ao longo da vigência do programa para que esse
                    continuamente possa ser melhorado.
                </li>
            </div>

            <div className='paragraph'>
                A empresa deve assumir o comando administrativo e operacional do PCMSO, de forma a garantir sua
                implementação, com a consciência que seu efetivo cumprimento estará diretamente relacionado à maior
                satisfação, motivação e melhoria da qualidade de vida dos trabalhadores, gerando assim, reflexos positivos em
                qualidade, produtividade e competitividade de suas atividades industriais.
            </div>
            <div className='tituloCap' data-new-page data-sum>9. MEDIDAS DE CONTROLE TÉCNICO</div>
            <div className='paragraph'>
                a) Realização dos exames médicos ocupacionais. Inspecionar ambientes x condições de trabalho e riscos de
                acordo com as necessidades diagnosticadas nos exames periódicos;
            </div>
            <div className='paragraph'>
                b) Encarregar dos exames complementares os profissionais e/ou entidades devidamente capacitados,
                equipados e qualificados.
            </div>
            <div className='tituloCap' data-sum>10. CRITÉRIOS PARA AVALIAÇÃO FUNCIONAL</div>
            <div className='tituloCap' data-sum>10.1. Exame Médico Admissional</div>
            <div className='paragraph'>
                Serão realizados, obrigatoriamente, antes que o trabalhador assuma suas atividades laborativas na Empresa.
            </div>
            <div className='paragraph'>
                O candidato será submetido à:
            </div>
            <div className='paragraph'>
                Exame Clínico composto de Anamnese ocupacional, exame físico e mental;
            </div>
            <div className='paragraph'>
                Exames Complementares realizados conforme exigência do cliente ; Exames Complementares realizados para
                os empregados cujas atividades envolvam riscos específicos, conforme discriminação no PGR, atendendo o
                disposto no Quadro I - Parâmetros para Controle Biológico da Exposição a Alguns Agentes Químicos, e no Quadro
                II - Parâmetro para Monitoração da Exposição Ocupacional a Alguns Riscos à Saúde, de acordo com os termos
                especificados na NR 7. Após a avaliação clínica e dos exames complementares solicitados realizados e analisados
                pelo médico, o candidato é considerado adequado ou não à função a que se propôs. Os objetivos do exame
                admissional são:
            </div>
            <div className='paragraph'>
                Avaliar se o empregado é capaz de desenvolver a tarefa da qual vai ser responsável, com segurança e eficiência,
                procurando identificar condições de saúde que predisponham aos acidentes de trabalho e às doenças
                ocupacionais; Identificar alterações de saúde que possam ser agravadas pelo exercício da função proposta.
            </div>
            <div className='paragraph'>
                Nota: Os exames complementares serão criteriosamente solicitados pelo Médico Coordenador do PCMSO, de
                acordo com a análise ocupacional de cada atividade e o que for considerado importante em virtude da avaliação
                clínica.
            </div>
            <div className='tituloCap' data-new-page data-sum>10.2. Exame Médico Periódico</div>
            <div className='paragraph'>
                O trabalhador será submetido à:
            </div>
            <div className='paragraph'>
                Exame Clínico composto de Anamnese ocupacional, exame físico e mental;
            </div>
            <div className='paragraph'>
                Exames Complementares realizados conforme requisitos do cliente.

            </div>
            <div className='paragraph'>
                Exames Complementares realizados para os empregados cujas atividades envolvam riscos específicos, conforme
                discriminação no PGR, atendendo o disposto no Quadro I - Parâmetros para Controle Biológico da Exposição a
                Alguns Agentes Químicos, e no Quadro II - Parâmetro para Monitoração da Exposição Ocupacional a Alguns
                Riscos à Saúde, de acordo com os termos especificados na NR 7.
            </div>
            <div className='paragraph'>
                Os objetivos dos exames periódicos são:
            </div>
            <div className='paragraph'>
                Avaliar as repercussões da atividade laboral na saúde do trabalhador;
            </div>
            <div className='paragraph'>
                Diagnosticar precocemente as alterações de saúde relacionadas ou não a atividade de trabalho
            </div>
            <div className='paragraph'>
                Nota: Os exames complementares serão criteriosamente solicitados pelo Médico Coordenador do PCMSO, de
                acordo com a análise ocupacional de cada atividade e o que for considerado importante em virtude da avaliação
                clínica
            </div>
            <div className='tituloCap' data-new-page data-sum>10.3. Exame Médico de Retorno ao Trabalho</div>
            <div className='paragraph'>
                Será realizado obrigatoriamente no 1º (primeiro) dia de retorno ao trabalho, em todo o trabalhador que estiver
                ausente por tempo igual ou maior do que 30 dias, por motivo de doença ou acidente, de origem ocupacional ou
                não, ou parto.
            </div>
            <div className='paragraph'>
                O trabalhador será submetido à:

            </div>
            <div className='paragraph'>
                Exame Clínico composto de Anamnese ocupacional, exame físico e mental;

            </div>
            <div className='paragraph'>
                Exames Complementares realizados conforme requisitos do cliente.
            </div>
            <div className='paragraph'>
                Exames Complementares realizados para os empregados cujas atividades envolvam riscos específicos, conforme
                discriminação no PGR, atendendo o disposto no Quadro I - Parâmetros para Controle Biológico da Exposição a
                Alguns Agentes Químicos, e no Quadro II - Parâmetro para Monitoração da Exposição Ocupacional a Alguns
                Riscos à Saúde, de acordo com os termos especificados na NR 7.
            </div>
            <div className='paragraph'>
                O objetivo do exame de retorno ao trabalho é:
            </div>
            <div className='paragraph'>
                Avaliar se o funcionário, após recuperação de sua saúde, mantém a capacidade de desenvolver a mesma
                atividade laboral anterior ao afastamento, com segurança e eficiência, procurando identificar condições de
                saúde que predisponham aos acidentes de trabalho e às doenças ocupacionais;

            </div>
            <div className='paragraph'>
                Nota 1: Caso não haja condição laboral plena, o médico deve orientar as áreas acerca das condições de
                trabalho para o qual o empregado está apto, permitindo a adaptação desse a novas atividades de trabalho.
            </div>
            <div className='paragraph'>
                Nota 2: Os exames complementares serão criteriosamente solicitados pelo Médico Coordenador do PCMSO,
                de acordo com a análise ocupacional de cada atividade e o que for considerado importante em virtude da
                avaliação clínica.
            </div>
            <div className='tituloCap' data-new-page data-sum>10.4. Exame Médico de Mudança de Função</div>
            <div className='paragraph'>
                Será realizado obrigatoriamente, antes da mudança de função, entendendo-se como mudança de função toda
                e qualquer alteração de atividade, posto de trabalho, setor ou unidade que implique na exposição do
                trabalhador a risco ocupacional diferente daquele a que estava exposto anteriormente. O trabalhador será
                submetido a:
            </div>
            <div className='paragraph'>
                - Exame Clínico composto de Anamnese ocupacional, exame físico e mental;
            </div>
            <div className='paragraph'>
                - Exames Complementares realizados conforme requisitos do cliente.

            </div>
            <div className='paragraph'>
                - Exames Complementares realizados para os empregados cujas atividades envolvam riscos específicos,
                conforme discriminação no PGR, atendendo o disposto no Quadro I - Parâmetros para Controle Biológico da
                Exposição a Alguns Agentes Químicos, e no Quadro II - Parâmetro para Monitoração da Exposição Ocupacional
                a Alguns Riscos à Saúde, de acordo com os termos especificados na NR 7.
            </div>
            <div className='paragraph'>
                Os objetivos do exame de mudança de função são:
            </div>
            <div className='paragraph'>
                Avaliar se o funcionário é capaz de desenvolver a nova tarefa da qual vai ser responsável, com segurança e
                eficiência, procurando identificar condições de saúde que predisponham aos acidentes de trabalho e às doenças
                ocupacionais;
            </div>
            <div className='paragraph'>
                Identificar alterações de saúde que possam ser agravadas pelo exercício da nova função proposta.
            </div>
            <div className='paragraph'>
                Nota: Os exames complementares serão criteriosamente solicitados pelo Médico Coordenador do PCMSO, de
                acordo com a análise ocupacional de cada atividade e o que for considerado importante em virtude da avaliação
                clínica.
            </div>
            <div className='tituloCap' data-new-page data-sum>10.5. Exame Médico Demissional</div>
            <div className='paragraph'>
                Será obrigatoriamente realizado até a data da homologação desde que o último exame médico ocupacional
                tenha sido realizado há mais de 90 (noventa) dias. O trabalhador será submetido à:
            </div>
            <div className='paragraph'>
                Exame Clínico composto de Anamnese ocupacional, exame físico e mental;
            </div>
            <div className='paragraph'>
                Exames Complementares realizados conforme requisitos do cliente. Exames Complementares realizados para
                os empregados cujas atividades envolvam riscos específicos, conforme discriminação no PGR, atendendo o
                disposto no Quadro I - Parâmetros para Controle Biológico da Exposição a Alguns Agentes Químicos, e no
                Quadro II - Parâmetro para Monitoração da Exposição Ocupacional a Alguns Riscos à Saúde, de acordo com os
                termos especificados na NR 7.
            </div>
            <div className='paragraph'>
                Os objetivos do exame demissional são:
            </div>
            <div className='paragraph'>
                Avaliar as repercussões da atividade laboral na saúde do trabalhador ao longo do tempo de exposição;
            </div>
            <div className='paragraph'>
                Diagnosticar precocemente as alterações de saúde, relacionadas ou não a atividade de trabalho, motivadoras
                ou não de inaptidão, que necessitem de tratamento médico especializado para o qual o médico deve
                encaminhá-lo mediante orientação, independente do seu desligamento ou não da empresa.
            </div>
            <div className='paragraph'>
                Nota: Os exames complementares serão criteriosamente solicitados pelo Médico Coordenador do PCMSO, de
                acordo com a análise ocupacional de cada atividade e o que for considerado importante em virtude da avaliação
                clínica.
            </div>
            <div className='tituloCap' data-sum>11. AVALIAÇÃO DOS RISCOS ANALISADOS</div>
            <div className='paragraph'>
                Este tem como objetivo proceder ao reconhecimento e avaliação do potencial dos riscos à saúde dos
                trabalhadores oriundos da exposição aos agentes de risco presentes nas atividades, ambientes e postos de
                trabalho. Aqui o PCMSO se inter-relaciona e sucede às ações previstas na NR-1 - Programa de Gerenciamento
                de Riscos (PGR), utilizando as informações levantadas pelo responsável técnico, relativos à mensuração e
                controle dos riscos encontrados.
            </div>
            <div className='tituloCap' data-sum>12. JUSTIFICATIVA TÉCNICA</div>
            <div className='paragraph'>
                O departamento médico, atendendo à legislação vigente (NR-7) e buscando um melhor selecionamento para os
                funcionários, devido à grande responsabilidade que lhes é incumbida, solicitará aos mesmos, quando
                submetidos a exames ocupacionais, os exames complementares mencionados no ANEXO I - Tabela e
                Cronograma de Ações de Monitoramento, e os exames médicos relacionados aos riscos avaliados por função.
            </div>
            <div className='tituloCap' data-sum>13. IMPORTÂNCIA E ASPECTOS DOS EXAMES COMPLEMENTARES</div>
            <div className='paragraph'>
                <li>
                    As periodicidades mínimas dos principais exames complementares estão descritas na Norma
                    Regulamentadora nº 7, que é a base legal do PCMSO. Quando não houver uma especificação clara na NR-7, a
                    periodicidade fica a critério do médico coordenador ou do agente de inspeção do Ministério do Trabalho (fiscal);
                </li>
            </div>
            <div className='paragraph'>
                <li>
                    O Departamento de Pessoal da empresa deve ficar atento aos prazos contidos no programa e a não
                    observância dos mesmos pode ser fator gerador de notificações e multas;

                </li>
            </div>
            <div className='paragraph'>
                <li>
                    As alterações de periodicidade que porventura se façam necessárias deverão ser comunicadas com
                    antecedência pela empresa Atento Medicina do Trabalho;

                </li>
            </div>
            <div className='paragraph'>
                <li>
                    As audiometrias realizadas durante o exame admissional deverão ser repetidas, por força da lei, conforme
                    NR-7 - Anexo I, com redação dada pela portaria nº 19, de 09/04/1998;
                </li>
            </div>
            <div className='paragraph'>
                <li>
                    Todos os casos de colaboradores com audiometrias alteradas por via aérea, deverão ser submetidos ao exame
                    por via óssea;
                </li>
            </div>
            <div className='paragraph'>
                <li>
                    Laudos para aposentadoria especial, LTCAT e PPP deverão ser baseados nos levantamentos ambientais
                    realizados pela contratação do PGR - Programa de Gerenciamento de Riscos, de acordo com a exigência da
                    Norma Regulamentadora nº 1;
                </li>
            </div>
            <div className='paragraph'>
                <li>
                    Perícias de insalubridade ou periculosidade não são objeto do PCMSO, devendo nesse caso ser contratado
                    perito assistente pela empresa I9 ENGENHARIA LTDA;
                </li>
            </div>
            <div className='paragraph'>
                <li>
                    Todos os colaboradores com resultados de exames alterados poderão ser convocados pelo médico do trabalho
                    e os mesmos deverão consultar durante o expediente, tendo a empresa o direito de solicitar comprovante de
                    comparecimento ao serviço médico;

                </li>
            </div>
            <div className='paragraph'>
                <li>
                    Os colaboradores cujos exames de laboratório apresentarem alteração poderão ser convocados para repetir
                    os exames;
                </li>
            </div>
            <div className='paragraph'>
                <li>
                    Os colaboradores que apresentarem alterações de exame clínico (ex.: pressão alta), poderão ser convocados
                    ao serviço médico e submetidos a outros exames que se façam necessários;
                </li>
            </div>
            <div className='paragraph'>
                <li>
                    Nos casos duvidosos, os colaboradores com alterações de sua saúde poderão ser encaminhados a outros
                    especialistas para esclarecimento de diagnóstico de doenças, especialmente ocupacionais (doenças do
                    trabalho).
                </li>
            </div>
            <div className='tituloCap' data-sum>14. EXAMES COM ALTERAÇÕES</div>
            <div className='paragraph'>
                A periodicidade do exame será reduzida e, nos casos que atinjam IBMP - Índice Biológico Máximo Permitido, os
                colaboradores serão trocados de função, evitando a sua exposição ao agente de risco até sua normalização. Nos
                casos de mudança de função por doença ocupacional ou suspeita da mesma e não ocorrer a melhora do quadro
                clínico, serão encaminhados à perícia médica do INSS para estabelecimento de nexo causal.
            </div>
            <div className='tituloCap' data-sum>15. ACIDENTES DE TRABALHO, EMERGÊNCIAS E/OU URGÊNCIAS</div>
            <div className='paragraph'>
                Todo colaborador que vier a sofrer um acidente de trabalho, emergências e/ou urgências, deverá ser
                encaminhado ao Pronto Socorro mais próximo.
            </div>
            <div className='paragraph'>
                Na ocorrência de acidente de trabalho, a CAT -Comunicação de Acidente de Trabalho -deverá ser emitida e
                entregue no prazo 24 horas.
            </div>
            <div className='tituloCap' data-sum>16. ATESTADO DE SAÚDE OCUPACIONAL - ASO</div>
            <div className='paragraph'>
                Para cada exame ocupacional realizado, previsto na NR 7, item 74.1, será emitido um atestado de saúde
                ocupacional (ASO) em 03 vias. A primeira via do ASO, ficará arquivada no local de trabalho, a disposição da
                fiscalização do trabalho, a segunda via ficará arquivada no prontuário médico do trabalhador e a terceira via
                será entregue ao trabalhador mediante recibo assinado na primeira via.
            </div>
            <div className='paragraph'>
                O médico examinador deve emitir uma conclusão, indicando uma das alternativas:
            </div>
            <div className='paragraph'>
                Apto para a função;
            </div>
            <div className='paragraph'>
                Inapto para a função.
            </div>
            <div className='paragraph'>
                Doenças e condições que devem contraindicar a admissão do candidato a emprego:

            </div>
            <div className='paragraph'>
                Doença que possa ser agravada pelas condições e ambiente de trabalho, independente das medidas de
                controle adotadas;
            </div>
            <div className='paragraph'>
                Doença irreversível acompanhada de deficiência orgânica ou psíquica capaz de comprometer o desempenho
                profissional com segurança;
            </div>
            <div className='paragraph'>
                Doença grave, irreversível e progressiva para a qual a terapêutica disponível não permita a recuperação da
                capacidade laboral;
            </div>
            <div className='paragraph'>
                Outras condições relacionadas à saúde que possam ser agravadas pelo exercício profissional, que incapacite
                para a função ou que ponha em risco a sua integridade física ou de terceiros.
            </div>
            <div className='paragraph'>
                No ASO, deverá constar obrigatoriamente:
            </div>
            <div className='paragraph'>
                Nome completo do trabalhador;
            </div>
            <div className='paragraph'>
                Número de registro de identidade (CPF ou RG);
            </div>
            <div className='paragraph'>
                Função do trabalhador;
            </div>
            <div className='paragraph'>
                Definição de apto ou inapto à função específica que exerce;
            </div>
            <div className='paragraph'>
                Indicação dos exames médicos e complementares que realizou e datas da realização;
            </div>
            <div className='paragraph'>
                Indicação dos riscos a que está exposto o trabalhador conforme tabela (anexo IV) da NR 7;
            </div>
            <div className='paragraph'>
                Nome do médico coordenador do PCMSO com CRM;
            </div>
            <div className='paragraph'>
                Nome do médico encarregado do exame com endereço ou forma de contato, data, carimbo com CRM e assinatura do exame;
            </div>
            <div className='paragraph'>
                Data e assinatura do candidato.
            </div>
            <div className='tituloCap' data-sum>17. ARQUIVAMENTO DA DOCUMENTAÇÃO</div>
            <div className='paragraph'>
                Todos os registros deverão ser arquivados por um período legal de 20 (vinte) anos, após o desligamento do
                trabalhador da empresa;
            </div>
            <div className='paragraph'>
                Os dados obtidos nos exames médicos, incluindo avaliação clínica e exames complementares, as conclusões e
                as medidas aplicadas deverão ser registrados em prontuário clínico individual, que ficará sob a responsabilidade
                do médico coordenador do Programa de Controle Médico de Saúde Ocupacional.
            </div>
            <div className='tituloCap' data-sum>18. RELATÓRIO ANUAL</div>
            <div className='paragraph'>
                O relatório anual deverá discriminar, por setores da empresa, o número e a natureza dos exames médicos,
                incluindo avaliações clínicas complementares e estatísticas de resultados considerados anormais.
            </div>
            <div className='tituloCap' data-sum>19. CONVÊNIOS MÉDICOS</div>
            <div className='paragraph'>
                Toda e qualquer questão de saúde não ocupacional fica sob inteira responsabilidade da empresa I9
                ENGENHARIA LTDA.
            </div>
            <div className='tituloCap' data-sum>20. PRIMEIROS SOCORROS</div>
            <div className='paragraph'>
                Item 7.5.1 NR-07 Todo estabelecimento deverá estar equipado com material necessário á prestação dos primeiros
                socorros, considerando-se as características da atividade desenvolvida, manter esse material guardado em local
                adequado e aos cuidados de pessoa treinada para esse fim.
            </div>
            <div className='paragraph'>
                LISTA DE MATERIAIS BÁSICOS DE PRIMEIROS SOCORROS
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        ALCOOL 70%
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        ATADURA DE CREPON
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        BAND AID
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        ESPARADRAPO
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        GAZES
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        LUVA DESCARTÁVEL
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        MICROPORE
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        SORO FISIOLÓGICO
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        TALA DE PAPELÃO
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        TERMÔMETRO
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                <ul>
                    <li>
                        TESOURA SEM PONTA
                    </li>
                </ul>
            </div>
            <div className='paragraph'>
                OBS: Os materiais de primeiros socorros podem ser utilizados pelos profissionais de saúde ou pelo profissional que
                trabalha no SESMT (Serviço Especializado em Engenharia de Segurança e em Medicina do Trabalho) e que seja
                treinado para utilização.
            </div>
            <div className='tituloCap' data-new-page data-sum>21. TERMO DE RESPONSABILIDADE</div>
            <div className='paragraph'>
                E, por estarem cientes das responsabilidades e procedimentos a serem adotados, assinam as partes o presente
                documento.
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '100px' }}>
                <div style={{ width: '45%', textAlign: 'center' }}>
                    <div style={{ borderTop: '1px solid #000', textAlign: 'center', paddingTop: '7px', marginBottom: '15px' }}>
                        {empresaRazaoSocial}
                    </div>

                </div>
                <div style={{ width: '45%', textAlign: 'center' }}>
                    <div style={{ borderTop: '1px solid #000', textAlign: 'center' }}>
                        {nomeResponsavel}
                        <div style={{ textAlign: 'center' }}>{crmResponsavel} {registroResponsavel}</div>
                    </div>

                </div>
            </div>

            <div className='tituloCap' data-new-page data-sum>22. ANEXO I - TABELA E CRONOGRAMA DE AÇÕES DE MONITORAMENTO</div>
            <div className='paragraph'>
                Este anexo descreve o cronograma de ações de monitoramento estabelecidas para cada função de acordo
                com os riscos ocupacionais e ambientais analisados:
            </div>
            <div className='table-div quadro-resumo'>
                <div className='table-tr'>
                    <div className='table-td th'>GHE</div>
                    <div className='table-td th'>FUNÇÃO</div>
                    <div className='table-td th'>Nº DE FUNCIONÁRIOS</div>
                    <div className='table-td th'>ATIVIDADES</div>
                </div>

                {funcoes.map((item: any) => (
                    <div className='table-tr' key={item.id}>
                        <div className='table-td' style={{ textAlign: 'center' }}>{item.pgrGhe?.nome ?? 'N/A'}</div>
                        <div className='table-td' style={{ textAlign: 'center' }}>{item.AteBaseFuncao?.nome ?? 'N/A'}</div>
                        <div className='table-td' style={{ textAlign: 'center' }}>
                            {item.num_tra_masc + item.num_tra_fem}
                        </div>
                        <div className='table-td' style={{ textAlign: 'center' }}>{item.descricao}</div>
                    </div>
                ))}
                <div style={{ fontWeight: 700 }}>Total de funcionários atual: {funcionariosTotal}.</div>
            </div>
            <div className='table-div quadro-funcao'>
                <div className='table-tr-funcao'>
                    <div className='table-td-funcao th'>FUNÇÃO</div>
                    <div className='table-td-funcao th'>GHE</div>
                </div>

                {funcoes.map((item: any) => (
                    <div className='table-tr-funcao'>
                        <div className='table-td-funcao'>{item.AteBaseFuncao?.nome ?? 'N/A'}</div>
                        <div className='table-td-funcao'>{item.pgrGhe?.nome ?? 'N/A'}</div>
                    </div>
                ))}
            </div>
            <div className='tituloCap' data-new-page data-sum>22.1 MONITORAMENTO MÉDICO DE CARGOS/FUNÇÕES</div>
            <div className='table-div quadro-funcao-risco'>
                {(() => {
                    const funcoesPorGhe: { [key: string]: any[] } = funcoes.reduce((acc: { [key: string]: any[] }, item: any) => {
                        const gheNome: string = item.pgrGhe?.nome ?? 'N/A';
                        if (!acc[gheNome]) {
                            acc[gheNome] = [];
                        }
                        acc[gheNome].push(item);
                        return acc;
                    }, {});


                    return Object.entries(funcoesPorGhe).map(([gheNome, listaFuncoes]: [string, any[]]) => (
                        <React.Fragment key={gheNome}>

                            <div className='table-tr'>
                                <div style={{ marginBottom: '10px' }}>{gheNome}</div>
                            </div>
                            <div className='table-tr'>
                                <div className='table-td-funcao th'>FUNÇÃO</div>
                                <div className='table-td-funcao th'>GHE</div>
                                <div className='table-td-funcao th'>DESCRIÇÃO</div>
                            </div>
                            {listaFuncoes.map((item) => (
                                <div className='table-tr' key={item.id}>
                                    <div className='table-td-funcao'>{item.AteBaseFuncao?.nome ?? 'N/A'}</div>
                                    <div className='table-td-funcao'>{item.pgrGhe?.nome}</div>
                                    <div className='table-td-funcao'>{item.descricao}</div>
                                </div>
                            ))}
                            {riscosFuncoes && (
                                <div>
                                    <div className='table-tr'>
                                        <div className='table-td-funcao th'>RISCOS OCUPACIONAIS:</div>
                                    </div>

                                    {(() => {
                                        const riscosAgrupados = listaFuncoes.reduce((acc: { [key: string]: Set<string> }, funcao: any) => {
                                            riscosFuncoes.filter((risco: any) => risco.id_funcao === funcao.id).forEach((riscoFiltrado: any) => {
                                                const categoria = riscoFiltrado.categoriaRisco.categoria;
                                                if (!acc[categoria]) {
                                                    acc[categoria] = new Set();
                                                }
                                                acc[categoria].add(riscoFiltrado.risco);
                                            });
                                            return acc;
                                        }, {});

                                        return Object.entries(riscosAgrupados).map(([categoria, riscosSet]: [string, Set<string>]) => (
                                            <div className='table-tr' key={categoria}>
                                                <div className='table-td-funcao' style={{ textAlign: 'center' }}>{categoria}</div>
                                                <div className='table-td-funcao'>
                                                    <ul>
                                                        {Array.from(riscosSet).map((risco, index) => (
                                                            <li key={index}>{risco}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        ));
                                    })()}
                                </div>
                            )}

                            {riscosExames && (
                                <div>
                                    <div className='table-tr-funcao'>
                                        <div className='table-td-exames th'>EXAMES:</div>
                                        <div className='table-td-exames th'>ADMISSIONAL</div>
                                        <div className='table-td-exames th'>APÓS ADM.</div>
                                        <div className='table-td-exames th'>PERIODICIDADE</div>
                                        <div className='table-td-exames th'>DEMISSIONAL</div>
                                        <div className='table-td-exames th'>MUD. DE RISCO</div>
                                        <div className='table-td-exames th'>RET. AO TRABALHO</div>
                                        <div className='table-td-exames th'>IDADE MIN.</div>
                                        <div className='table-td-exames th'>IDADE MAX.</div>
                                    </div>

                                    {(() => {
                                        const examesExibidos = new Set();

                                        return listaFuncoes.flatMap((funcao: any) =>
                                            riscosFuncoes.filter((risco: any) => risco.id_funcao === funcao.id).flatMap((riscoFiltrado: any) =>
                                                riscosExames.filter((exame: any) => exame.id_risco === riscoFiltrado.id_base_risco).map((exameFiltrado: any) => {
                                                    if (!examesExibidos.has(exameFiltrado.id)) {
                                                        examesExibidos.add(exameFiltrado.id);
                                                        return (
                                                            <div className='table-tr-funcao' key={exameFiltrado.id}>
                                                                <div className='table-td-exames'>{exameFiltrado.ateBaseExames.nome}</div>
                                                                <div className='table-td-exames'>{exameFiltrado.adm === 1 ? 'X' : ''}</div>
                                                                <div className='table-td-exames'>{exameFiltrado.apos_adm ? exameFiltrado.apos_adm + ' Meses' : ''}</div>
                                                                <div className='table-td-exames'>{exameFiltrado.periodicidade ? exameFiltrado.periodicidade + ' Meses' : ''}</div>
                                                                <div className='table-td-exames'>{exameFiltrado.dem === 1 ? 'X' : ''}</div>
                                                                <div className='table-td-exames'>{exameFiltrado.mud_fun === 1 ? 'X' : ''}</div>
                                                                <div className='table-td-exames'>{exameFiltrado.ret_tra === 1 ? 'X' : ''}</div>
                                                                <div className='table-td-exames'>{exameFiltrado.per_id1}</div>
                                                                <div className='table-td-exames'>{exameFiltrado.per_id2}</div>
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })
                                            )
                                        );
                                    })()}
                                </div>
                            )}
                        </React.Fragment>
                    ));
                })()}
            </div>

            <div className='table-div cronograma' data-landscape>
                <div className='tituloCap' data-new-page data-sum>23. ANEXO II - CRONOGRAMA DE AÇÕES ANUAL DO PCMSO</div>
                <div className='table-tr ' style={{ borderTop: '1px solid #000' }}>
                    <div className='table-td th'>Item</div>
                    <div className='table-td th'>Ação Planejada</div>
                    {intervalosCronograma.map((intervalo: any, index) => (
                        <div key={index} className='table-td th'>
                            {formatarIntervaloExecucoes(intervalo.intervalo_execucoes)}
                        </div>
                    ))}
                    <div className='table-td th'>Data de Execução</div>
                    <div className='table-td th'>Responsável</div>
                </div>
                {acoesCronograma.map((acao: any) => (
                    acao.descricao ? (
                        <>
                            <div className='table-tr'>
                                <div className='table-td'>Programado</div>
                                <div className='table-td'>{acao.descricao}</div>
                                {acao.execucoes.map((intervalo: any, index: any) => (
                                    <div key={index} className='table-td'>
                                        {acao.execucoes.find((e: any) => e.id === intervalo.id && e.executada) ? "X" : ""}
                                    </div>
                                ))}
                                <div className='table-td'> {acao.data_inicial ? formatarDataISO(acao.data_inicial) : ''}</div>
                                <div className='table-td'>{acao.responsavel}</div>

                            </div>

                            <div className='table-tr'>
                                <div className='table-td'>Realizado</div>
                                <div className='table-td'>{acao.descricao}</div>
                                {acao.execucoes.map((intervalo: any, index: any) => (
                                    <div key={index} className='table-td'>
                                    </div>
                                ))}
                                <div className='table-td'>{acao.data_inicial ? formatarDataISO(acao.data_inicial) : ''}</div>
                                <div className='table-td'>{acao.responsavel}</div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className='table-tr'>
                                <div className='table-td'>Não há dados para serem apresentados</div>
                            </div>
                        </>
                    )
                ))}
                <div className='paragraph'>Cabe a empresa definir os prazos para programar as ações acima propostas.</div>
            </div>























        </>
    );
}
